import React from "react";
import {
    MDBFooter,
    MDBContainer,
    MDBCol,
    MDBRow,
    MDBIcon,
  } from 'mdb-react-ui-kit';

function Footer() {
  return (

    <MDBFooter bgColor='dark' className='text-center text-lg-start text-muted'>
      <section 
      className='d-flex justify-content-center justify-content-lg-between p-5 border-bottom' 
      style={{backgroundColor:'white'}}>
      </section>

      <section className='' style={{color:'light'}}>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4'>
                <MDBIcon icon="gem" className="me-3" />
                AH | FITNESS
              </h5>
              <h6>
                -Train body and mind-
              </h6>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Products</h6>
              <p>
                <a href='https://reactjs.org/' className='text-reset'>
                  React JS
                </a>
              </p>
              <p>
                <a href='https://react-bootstrap.github.io/' className='text-reset'>
                  Bootstrap 5
                </a>
              </p>

              <p>
                <a href='https://sass-lang.com/' className='text-reset'>
                  Sass
                </a>
              </p>
            </MDBCol>

            

            <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Contact</h6>
              <p>
                <MDBIcon className="me-2" />
                 Prishtinë, 10000, Kosovë
              </p>
              <p>
                <MDBIcon className="me-3" />
                  <a href="mailto:ardi.halilaj997@gmail.com">ardi.halilaj@gmail.com</a>
              </p>
              <p>
                <MDBIcon className="me-3" />  + 383 48 521 388
              </p>

            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.10)' }}>
        © 2023 Copyright:<b>ReactBootstrap</b>
      </div>
    </MDBFooter>

  );
}

export default Footer;